import request from '@/utils/request'
import qs from 'qs'
// 获取车辆列表
export function GetCarList (params) {
  return request({
    url: '/data/getData',
    method: 'post',
    params
  })
}

// 获取综合监视信息（用户数，车辆数，在线率，报警数）
export function GetCarInfo () {
  return request({
    url: '/car/home/getCarInfo',
    method: 'post'
  })
}

// 获取报警信息
export function GetAlarmList () {
  return request({
    url: '/car/home/getAlarmList',
    method: 'post'
  })
}

// 获取天气预报信息
export function GetWeatherInfo (data) {
  return request({
    url: '/car/home/getWeather',
    method: 'post',
    data
  })
}

//获取首页饼图数据
export function GetChartData () {
  return request({
    url: '/car/home/getChartData',
    method: 'post'
  })
}

// 获取车辆信息
export function GetCarData (data) {
  return request({
    url: '/data/get/carDetail/',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取车辆经纬度信息
export function queryCarCoordinate (data) {
  return request({
    url: '/data/queryCarCoordinate/',
    method: 'post',
    data: qs.stringify(data)
  })
}


// 获取车辆经纬度轨迹信息
export function queryTraceCarCoordinate (data) {
  return request({
    url: '/data/trace/queryTraceCarCoordinate',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取车辆轨迹
export function getVehicleTrace (data) {
  return request({
    url: '/data/trace/getVehicleTrace',
    method: 'post',
    params: data
  })
}

//获取设备状态
export function getCarState (data) {
  return request({
    url: '/car/get/carState',
    method: 'get',
    params: data
  })
}
//获取公司列表
export function getCompanyList () {
  return request({
    url: '/data/getCompanys',
    method: 'get'
  })
}